module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Control_Select_I18n', {

		configure: function(options) {
			this.registerOptions('', {
				autoRender: false,
				manualRender: true
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			if (!fox.isEmpty(fox.i18n.lang) && fox.isEmpty(fox.i18n.phrases[fox.i18n.lang])) {
				this.waitEvent('@root #dictionary', 'loaded', fox.bind(function () {
					this.setOption('autoRender', true);
					this.setOption('manualRender', false);
					this.render();
				}, this));
			} else {
				this.setOption('autoRender', true);
				this.setOption('manualRender', false);
			}

			this.callParent('running', arguments);
		}

	}, 'Control_Select');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/controls/selectI18n.js
// module id = 306
// module chunks = 2